/* eslint-disable func-names */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-const-assign */
/* eslint-disable no-throw-literal */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
export const CSRF_TOKEN_COOKIE_NAME = 'csrf_token';
export const CSRF_TOKEN_HEADER_NAME = 'x-csrf-token';
export const REQUESTED_ACCOUNT_ID_HEADER_NAME = 'x-req-acc-id';
export const KEY_USER_ID = 'KEY_USER_ID';
export const KEY_REQUESTED_ACCOUNT_ID = 'KEY_REQUESTED_ACCOUNT_ID';
export const KEY_ACCESSIBLE_ACCOUNTS = 'KEY_ACCESSIBLE_ACCOUNTS';
export const VALID_CSRF_TOKEN_CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const RANDOM_CSRF_TOKEN_LENGTH = 12;

export function getRandomStringFromValidChars(stringValidChars, length) {
    let ret = '';
    const randomArray = new Uint8Array(length);
    const Uint8MaxValue = 255;
    const crypto = window.crypto || window.msCrypto;
    crypto.getRandomValues(randomArray);
    for (let i = 0; i < length; i++) {
        const char = stringValidChars.charAt(Math.floor((randomArray[i] * stringValidChars.length) / Uint8MaxValue));
        if (!char) {
            char = stringValidChars.charAt(0);
        }
        ret += char;
    }
    return ret;
}

export function getCookies() {
    // eslint-disable-next-line prefer-const
    let returnDict = {};
    const splitPairs = document.cookie.split(';');
    for (let i = 0; i < splitPairs.length; i++) {
        const keyValue = splitPairs[i].split('=');
        returnDict[keyValue[0]] = keyValue[1];
    }
    return returnDict;
}

export function getCsrfToken() {
    let tokenFromCookie = getCookies()[CSRF_TOKEN_COOKIE_NAME];
    if (tokenFromCookie === undefined || tokenFromCookie.length !== RANDOM_CSRF_TOKEN_LENGTH || tokenFromCookie === 'undefined') {
        tokenFromCookie = getRandomStringFromValidChars(VALID_CSRF_TOKEN_CHARS, RANDOM_CSRF_TOKEN_LENGTH);
        document.cookie = `${CSRF_TOKEN_COOKIE_NAME}=${tokenFromCookie}; path=/; SameSite=Strict; secure`;
    }
    return tokenFromCookie;
}

export function getRequestedAccountId() {
    const fromSession = sessionStorage.getItem(KEY_REQUESTED_ACCOUNT_ID);
    if (fromSession && fromSession !== 'undefined') {
        return fromSession;
    }
    const fromLocal = localStorage.getItem(KEY_REQUESTED_ACCOUNT_ID);
    if (fromLocal && fromLocal !== 'undefined') {
        return fromLocal;
    }
    return undefined;
}

function buildHeaders(method) {
    const headers = {};
    const requestedAccountId = getRequestedAccountId();
    if (requestedAccountId) headers[REQUESTED_ACCOUNT_ID_HEADER_NAME] = requestedAccountId;
    if (method === 'POST') {
        headers[CSRF_TOKEN_HEADER_NAME] = getCsrfToken();
        headers['Content-Type'] = 'application/json';
    }
    return headers;
}

function downloadBlob(blob, responseHeaders) {
    const url = window.URL.createObjectURL(blob);
    const filename = responseHeaders.get('content-disposition').split('filename=')[1].split(';')[0].replaceAll('"', '');
    const tempLink = document.createElement('a');
    tempLink.style = 'display: none';
    document.body.appendChild(tempLink);
    tempLink.href = url;
    tempLink.download = filename;
    tempLink.click();
    window.URL.revokeObjectURL(url);
}

export async function doBackendRequestForDownload(method, path, successCallback, payload, failureCallback) {
    if (path.indexOf('//') === 0 || path.indexOf('/') !== 0) {
        throw 'fetchBackendRequest should only target internal endpoints';
    }

    const requestHeaders = buildHeaders(method);
    const requestParams = {
        method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: requestHeaders,
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: payload,
    };

    let responseHeaders;
    await fetch(path, requestParams)
        .then((response) => {
            if (response.ok) {
                responseHeaders = response.headers;
                return response.blob();
            }
            failureCallback();
            return undefined;
        }).then((blob) => {
            downloadBlob(blob, responseHeaders);
            successCallback();
        }).catch(() => {
            failureCallback();
        });
}

export function doBackendRequest(method, path, successCallback, payload, failureCallback) {
    if (path.indexOf('//') === 0 || path.indexOf('/') !== 0) {
        throw 'doBackendRequest should only target internal endpoints';
    }
    // eslint-disable-next-line prefer-const
    let xhr = new XMLHttpRequest();
    xhr.open(method, path, true);
    const requestedAccountId = getRequestedAccountId();
    if (requestedAccountId) {
        xhr.setRequestHeader(REQUESTED_ACCOUNT_ID_HEADER_NAME, requestedAccountId);
    }
    if (method.toUpperCase() === 'POST') {
        xhr.setRequestHeader(CSRF_TOKEN_HEADER_NAME, getCsrfToken());
        xhr.setRequestHeader('Content-Type', 'application/json');
    }
    xhr.ontimeout = function () {
        failureCallback(undefined);
    };
    xhr.onload = function () {
        let responseJson = {};
        try {
            responseJson = JSON.parse(xhr.responseText);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            if (failureCallback !== undefined) {
                failureCallback(undefined);
            }
        }
        if (xhr.status === 200) {
            successCallback(responseJson);
        } else if (failureCallback !== undefined) {
            failureCallback(responseJson);
        }
    };
    if (payload !== undefined && method.toUpperCase() === 'POST') {
        xhr.send(payload);
    } else {
        xhr.send();
    }
}
